




















































import { Component, Prop, Emit } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'

import { dateTimeToDisplay, dateToDisplay } from '@/utils/dateTime'
import { Contact } from '@/modules/Contact/interfaces/contact'
import FoldingCard from '@/components/FoldingCard.vue'
import PolicyDialog from '../../Policy/scripts/policy-dialog'
import { policyStatus, policyStatusClass } from '@/modules/Policy/helpers/policy'
import dollarFilter from '@/utils/dollarFilter'

@Component({
  components: {
    FoldingCard
  }
})
export default class ContactDetailPolicy extends mixins(PolicyDialog) {
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  tableColumn = [
    { field: 'policyNumber',
      title: 'Policy Number',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.policyNumber || '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'policyName',
      title: 'Policy Name',
      slots: { default: 'name_default' },
      resizable: true
    },
    { field: 'status', title: 'Status', slots: { default: 'status_default' }, resizable: true, width: 160 },
    { field: 'carrierName',
      title: 'Carrier',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.carrier ? row.carrier.name : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'premium',
      title: 'Premium',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.premium ? dollarFilter(row.premium) : '-')
        ]
      }
      },
      resizable: true
    },
    { field: 'effectiveDate',
      title: 'Effcetive Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.effectiveDate ? dateToDisplay(row.effectiveDate) : '-')
        ]
      }
      },
      resizable: true,
      width: 140
    },
    { field: 'expirationDate',
      title: 'Expiration Date',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.expirationDate ? dateToDisplay(row.expirationDate) : '-')
        ]
      }
      },
      resizable: true,
      width: 140
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 90 }
  ]

  get policyList () {
    return this.contact.policies || []
  }

  dateTimeToDisplay = dateTimeToDisplay
  dateToDisplay = dateToDisplay

  policyStatus = policyStatus
  policyStatusClass = policyStatusClass

  @Emit('refresh')
  onSuccess () {
    // do nothing
  }

  routeToDetail (item: any) {
    this.$router.push({
      name: 'PolicyDetailDetail',
      params: {
        id: item.id
      }
    })
  }

  async deletePolicyConfirm () {
    await this.deletePolicyPost()
    this.onSuccess()
  }

  routeToAllList (type: string) {
    this.$router.push({
      name: 'ContactRelatedPoliciesList',
      params: {
        id: this.contact.id + '',
        fromName: this.contact.name
      }
    })
  }
}
